module.exports = "https://coursera_assets.s3.amazonaws.com/images/6d1367ed9fc2050cbcc97b52ea9b1283.png";